import React from 'react';

export default function MailIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="mail" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ic/mail_outline">
          <g>
            <mask id="mask-2-mail" fill="white">
              <path
                d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,18 L4,18 L4,8 L12,13 L20,8 L20,18 Z M12,11 L4,6 L20,6 L12,11 Z"
                id="path-1"></path>
            </mask>
            <g id="Shape" fill-rule="nonzero"></g>
            <g id="Blue-/-B400" mask="url(#mask-2-mail)" fill="#0065FF">
              <rect id="B400" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
